import api from '../config/axiosConfig';

export const PostulanteService = {
    fetchPostulantes: async ({ token,desde, hasta,nombre, estado,order, page = 1, limit = 20 }) => {
        try {
            const response = await api.get('/postulantes', {
                headers: { Authorization: `Bearer ${token}` },
                params: { estado,desde, hasta,nombre,order, page, limit },
            });

            return {
                postulantes: response.data.postulantes || [],
                totalPages: response.data.totalPages || 1,
                totalRegistros: response.data.total || 0,
            };
        } catch (error) {
            console.error('Error en PostulanteService.fetchPostulantes:', error);
            throw error;
        }
    },
    registrarPostulante: async (token, datosPostulante) => {
        try {
            const response = await api.post('/postulantes', datosPostulante, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error en PostulanteService.registrarPostulante:', error);
            throw error;
        }
    },
    fetchPostulanteById: async (token, id) => {
        try {
            const response = await api.get(`/postulantes/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error en PostulanteService.fetchPostulanteById:', error);
            throw error;
        }
    },
    actualizarPostulante: async (token, id, datosActualizados) => {
        try {
            const response = await api.put(`/postulantes/${id}`, datosActualizados, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error en PostulanteService.actualizarPostulante:', error);
            throw error;
        }
    },
    contactarPostulante: async (token, id, datosContacto) => {
        try {
            const response = await api.post(`/postulantes/${id}/contactar`,
                datosContacto,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            return response.data;
        } catch (error) {
            console.error('Error en PostulanteService.contactarPostulante:', error);
            throw error;
        }
    },
    entrevistarPostulante: async (id, formData, token) => {
        try {
            const response = await api.post(`/postulantes/${id}/entrevistar`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error al PostulanteService.entrevistarPostulante:', error);
            throw error;
        }
    }
};
